import { omitBy, mapKeys } from "lodash";

export const getDTMFKeyErrorPrefix = (
  stepIdx,
  key,
  activeTab = "person",
  templateType = "voiceTemplate"
) =>
  `${templateType}.freeswitch.dialPlan.${activeTab}.steps.${stepIdx}.keys.${key}.`;
export const getDTMFKeyErrorKeyShouldMismatch = (
  stepIdx,
  key,
  activeTab = "person",
  templateType = "voiceTemplate"
) =>
  `${getDTMFKeyErrorPrefix(
    stepIdx,
    key,
    activeTab,
    templateType
  )}KeyShouldMismatch`;
export const getDTMFKeyErrorPath = (
  stepIdx,
  key,
  activeTab = "person",
  templateType = "voiceTemplate"
) => `${getDTMFKeyErrorPrefix(stepIdx, key, activeTab, templateType)}path`;
export const keyShouldMismatchErrorValue = "Should not match Opt-out key";
export const invalidVoiceFileTypeErrorValue =
  "Upload a valid mp3, wav, m4a or ogg file";
export const voiceFileUploadDefaultLabel =
  "Upload an audio file by clicking or drag-and-drop";
export const getStepErrorPrefix = (
  stepIdx,
  activeTab = "person",
  templateType = "voiceTemplate"
) => `${templateType}.freeswitch.dialPlan.${activeTab}.steps.${stepIdx}.`;
export const getStepErrorPrefixNoStepIdx = (
  activeTab = "person",
  templateType = "voiceTemplate"
) => `${templateType}.freeswitch.dialPlan.${activeTab}.steps.`;
export const getStepErrorPath = (
  stepIdx,
  activeTab = "person",
  templateType = "voiceTemplate"
) => `${getStepErrorPrefix(stepIdx, activeTab, templateType)}path`;
export const getStepErrorVariableValue = (
  stepIdx,
  activeTab = "person",
  templateType = "voiceTemplate"
) => `${getStepErrorPrefix(stepIdx, activeTab, templateType)}variableValue`;
export const getStepErrorVariableName = (
  stepIdx,
  activeTab = "person",
  templateType = "voiceTemplate"
) => `${getStepErrorPrefix(stepIdx, activeTab, templateType)}variableName`;

export const cleanupStepErrorsGeneric = (
  errors,
  deletedIndex,
  getStepPrefixToDeleteFn,
  getStepPrefixToShiftFn
) => {
  const stepPrefixToDelete = getStepPrefixToDeleteFn(deletedIndex);
  const stepPrefixToShift = getStepPrefixToShiftFn();
  // Remove errors for the deleted step
  const cleanedErrors = omitBy(errors, (_, key) =>
    key.startsWith(`${stepPrefixToDelete}`)
  );

  // Shift down the remaining step errors
  const shiftedErrors = mapKeys(cleanedErrors, (value, key) => {
    const match = key.match(
      new RegExp(`^(${stepPrefixToShift})(\\d+)(\\..+)$`)
    );

    if (match) {
      const [, base, indexStr, suffix] = match;
      const index = parseInt(indexStr, 10);

      if (index > deletedIndex) {
        return `${base}${index - 1}${suffix}`;
      }
    }

    return key;
  });

  return shiftedErrors;
};
export function getFilteredErrorsAfterBaseFilePathChange(
  errors,
  idx,
  getStepPrefixFn
) {
  // dtmf errors: Filter out base file upload errors but
  // leave keys-specific file upload errors belonging to dtmf in this index
  const stepErrorPrefix = getStepPrefixFn(idx);
  const DTMFKeysErrorPrefix = `${stepErrorPrefix}.keys`;

  return Object.fromEntries(
    Object.entries(errors).filter(
      ([key]) =>
        !key.startsWith(stepErrorPrefix) || key.startsWith(DTMFKeysErrorPrefix)
    )
  );
}
